import ContextualMenuItem, { ContextualMenuItemProps } from './ContextualMenuItem';

export type { ContextualMenuItemProps };
export default ContextualMenuItem;
